<template>
  <div class="chart-wrapper print-chart-wrapper mt-15">
    <div class="date-side" v-if="!loading">
      <div
        v-for="(day, index) in calculatedData"
        :key="day.Date"
        class="day-item"
        :style="{
          height: dateHeight + 'px'
        }"
      >
        <div class="day-title">
          <div>Day {{ index + 1 }}</div>
          <div>
            {{
              userLang.indexOf('en') > -1
                ? moment(day.Date).format('DD MMM YY')
                : moment(day.Date).format('DD/MM/YY')
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="wp-100">
      <div class="chart-content">
        <LoadingAnimation v-if="loading" />
        <div
          v-else
          v-for="day in calculatedData"
          :key="day.Date"
          class="day-item"
          :style="{
            height: dateHeight + 'px'
          }"
        >
          <div class="day-icon-content" v-if="day.ActivitiesData.length">
            <div
              v-for="hourItem in day.ActivitiesData"
              :key="hourItem.Hour"
              class="hour-item"
              :style="{
                left: hourItem.LeftPercentage + '%'
              }"
            >
              <el-tooltip
                v-if="hourItem.Events && hourItem.Events.length"
                effect="light"
                placement="top"
                popper-class="activity-chart-toolbar-box-popup toolbar-box-popup"
              >
                <div slot="content">
                  <div
                    v-for="(event, index) in hourItem.Events"
                    :key="index"
                    class="item"
                  >
                    <span
                      :class="
                        getEventInfo(event, hourItem.TotalActivityTime).class
                      "
                      class="icon"
                    ></span>
                    <span class="label">{{
                      getEventInfo(event, hourItem.TotalActivityTime).label
                    }}</span>
                    <span class="time">{{
                      event.TotalActivityTime | minuteFormat
                    }}</span>
                  </div>
                </div>
                <div class="bar-chart-item pointer">
                  <div
                    v-for="(event, index) in hourItem.Events"
                    :key="index"
                    :class="
                      getEventInfo(event, hourItem.TotalActivityTime).class
                    "
                    :style="{
                      height:
                        getEventInfo(event, hourItem.TotalActivityTime).height +
                        'px'
                    }"
                  ></div>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="hour-title">
        <span
          v-for="hour in hours"
          :key="hour.value"
          class="hour-item pt-2 pb-2"
          :class="hour.active ? 'active' : ''"
          >{{ hour.show ? hour.label : '' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { images, hours } from '@/const.js'
import { physicalActivityEventType } from '@/components/patients/charts/smartzEventsChart/SmartzEventConst.js'
import LoadingAnimation from '@/components/patients/charts/LoadingAnimation'
export default {
  data() {
    return {
      images,
      moment,
      physicalActivityEventType,
      userLang: navigator.language || navigator.userLanguage,
      hours,
      calculatedData: [],
      dateHeight: 150
    }
  },
  props: {
    chartData: {
      type: Array,
      require: true
    },
    loading: {
      type: Boolean,
      require: true
    }
  },
  components: {
    LoadingAnimation
  },
  watch: {
    chartData() {
      this.getCalculatedData()
    }
  },
  computed: {
    getEventInfo() {
      return (event, hourTotalActivityTime) => {
        // Usually the sum of activity time will be max 60 minutes but there are few anamolies which makes the sum higher than expected
        let base = hourTotalActivityTime > 60 ? hourTotalActivityTime : 60

        let info
        info = {
          class: '',
          // 20 is the distance between the barchart and the top
          // TotalActivityTime is in minutes, so should devide 60
          height: (event.TotalActivityTime / base) * (this.dateHeight - 20),
          label: ''
        }
        switch (event.ActivityType) {
          case this.physicalActivityEventType.low:
            info.class = 'status1'
            info.label = this.$t('text.low')
            break
          case this.physicalActivityEventType.medium:
            info.class = 'status2'
            info.label = this.$t('text.medium')
            break
          case this.physicalActivityEventType.high:
            info.class = 'status3'
            info.label = this.$t('text.high')
            break
          default:
            info.class = 'status1'
        }
        return info
      }
    }
  },
  methods: {
    getCalculatedData() {
      let hours = Array.from({ length: 24 }, (_, index) => index)
      this.calculatedData = []

      let allDates = []
      let startDate = moment(this.$store.state.patient.selectedDateRange[0])
      let endDate = moment(this.$store.state.patient.selectedDateRange[1])
      let currentDate = moment(startDate)
      while (currentDate <= endDate) {
        allDates.push(currentDate.clone().toDate())
        currentDate.add(1, 'day')
      }

      allDates.forEach(date => {
        let dayData = this.chartData.find(day =>
          moment(day.Date).isSame(date, 'day')
        )
        if (dayData) {
          let tmp = {
            Date: dayData.Date,
            ActivitiesData: []
          }
          hours.forEach(hour => {
            tmp.ActivitiesData.push(
              this.getDataByHour(hour, dayData.ActivitiesData)
            )
          })
          this.calculatedData.push(tmp)
        } else {
          this.calculatedData.push({
            Date: moment(date).format('YYYY-MM-DD'),
            ActivitiesData: []
          })
        }
      })
    },
    getDataByHour(hour, activitiesData) {
      let obj = activitiesData.filter(item => item.Hour == hour)
      obj =
        obj && obj.length
          ? obj[0]
          : {
              ActivityData: 3.5,
              Events: [],
              Hour: hour,
              TotalActivityTime: 0
            }
      obj.LeftPercentage = (parseInt(obj.Hour) / 24) * 100
      obj.Events = this.sortActivities(obj.Events)
      return obj
    },
    sortActivities(activities) {
      return Object.values(this.physicalActivityEventType)
        .map(activityType => {
          return activities.find(
            activity => activity.ActivityType === activityType
          )
        })
        .filter(activity => activity)
    }
  }
}
</script>
